export default __webpack_public_path__ + "static/media/Raga Diamonds.e59234ff.png";